import { RootState } from 'typesafe-actions';
import createPersistedState from 'use-persisted-state';
import { REDUX_STORAGE_KEY } from './constants';

const useReduxState = createPersistedState<
  | Pick<RootState, 'wallet' | 'currencies' | 'theme' | 'featureSpotlights'>
  | undefined
>(REDUX_STORAGE_KEY);

export const useReduxStorage = () => {
  const [reduxState, setReduxState] = useReduxState(undefined);

  return {
    reduxStorageState: reduxState,
    setReduxStorageState: setReduxState,
  };
};
